import type { NskResponse } from '~/models/Api';
import { postRequest } from '~/utils/api/api_handler';

const paths = {
  create: '/deals/:deal_id/deal_memorandum_files'
};

export const create = async (
  file: File,
  dealId: number
): Promise<NskResponse<void>> => {
  const params = new FormData();
  params.append('file', file);
  return postRequest(paths.create.replace(':deal_id', String(dealId)), params);
};
